// Constants for most common wallets
export const COINBASE = "com.coinbase.wallet";
export const METAMASK = "io.metamask";
export const RAINBOW = "me.rainbow";
export const ZERION = "io.zerion.wallet";
//# sourceMappingURL=constants.js.map